var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.959961 7.2001H15.0399C15.5702 7.2001 16 6.77043 16 6.23988C16 5.70932 15.5703 5.27979 15.0399 5.27979H0.959961C0.42967 5.27992 0 5.70946 0 6.23988C0 6.7703 0.42967 7.2001 0.959961 7.2001Z",
    fill: "#202329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.959961 2.71998H15.0399C15.5702 2.71998 16 2.29018 16 1.75989C16 1.2296 15.5703 0.799927 15.0399 0.799927H0.959961C0.42967 0.799927 0 1.2296 0 1.75989C0 2.29018 0.42967 2.71998 0.959961 2.71998Z",
    fill: "#202329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.f0c9ab87dd0b5e3086928ee4cc5a8156.svg";
export { ForwardRef as ReactComponent };